import sidebar from '@/config/sidebars/geogrids'
import createVueApp from '@/common/create_app'
import { useGeogridsCommonStore } from '@/stores/geogrids/common'

// The full payload hydrates the common geogrids store (it picks what it
// needs). The component only receives its per-page params — passing the rest
// would turn them into fallthrough attrs on a fragment root and trip Vue's
// "extraneous attrs" warning.
const hydrateCommon = (data) => (pinia) => {
  useGeogridsCommonStore(pinia).initialize(data)
}

Styxie.Initializers.ScheduledGeogrids = {
  index: async(props) => {
    const { default: Component } = await import('@/vue_widgets/geogrids/scheduled/index/index.vue')
    createVueApp(Component, { sidebar, state: hydrateCommon(props) })
  },
  new: async(props) => {
    const { default: Component } = await import('@/vue_widgets/geogrids/scheduled/form/index.vue')
    createVueApp(Component, { sidebar, state: hydrateCommon(props) })
  },
  edit: async(props) => {
    const { default: Component } = await import('@/vue_widgets/geogrids/scheduled/form/index.vue')
    const { configId } = props
    createVueApp(Component, { props: { configId }, sidebar, state: hydrateCommon(props) })
  },
  show: async(props) => {
    const { default: Component } = await import('@/vue_widgets/geogrids/scheduled/show/index.vue')
    const { configId, geogridId } = props
    createVueApp(Component, { props: { configId, geogridId }, sidebar, state: hydrateCommon(props) })
  }
}
